export default {
  topicCategorysItem: [],
  areaCategorysItem: [],
  topicCategorysBook: [],
  areaCategorysBook: [],
  indexArea: [],
  itemList: {},
  readingType: JSON.parse(localStorage.getItem(`itemType`)) || -1,
  userinfo: JSON.parse(localStorage.getItem(`userinfo`)) || {}, // userinfo
  LOADING: false,
  filterList: JSON.parse(localStorage.getItem(`filterList`)) || []
}



// WEBPACK FOOTER //
// ./src/store/state.js